// import invoice from '../../store/modules/sales/invoice';
import permissions from '../../data/permissions';

import order from './order';
import supplier from './supplier';
import invoice from './invoice';
import requisition from './requisition';
import payment from './payment'
import receipt from './goodReceipt'
import creditNote from './creditNote';
import supplierGroup from './supplierGroup';
import supplierAccount from './supplierAccount';
import SupplierContact from './SupplierContact';
import debitNote from './debitNote'
import generalReceipt from './generalReceipt';
import paymentMode from './paymentMode';
import goodReturn from './goodReturn';
import landedCostComponent from './landedCostComponent';
import landedCost from './landedCost';

export default {
    path: '/purchase',
    component: () => import('../../layouts/PurchaseLayout.vue'),
    meta: { requiresAuth: true },
    children: [
        ...order,
        ...supplier,
        ...invoice,
        ...requisition,
        ...payment,
        ...receipt,
        ...creditNote,
        ...supplierGroup,
        ...supplierAccount,
        ...SupplierContact,
        ...debitNote,
        ...paymentMode,
        ...generalReceipt,
        ...goodReturn,
        ...landedCostComponent,
        ...landedCost,
        {
            name: "PriceChecker",
            path: "price-checker",
            component: () => import('./../../views/purchase/PriceCheckerView.vue'),
            meta: { requiresAuth: true, authorization: permissions.purchase_order.create }
        },
        {
            name: "Dashboard",
            path: "dashboard",
            component : () => import('./../../views/purchase/DashboardView.vue'),
            meta: { requiresAuth: true, authorization: permissions.report.purchase_dashboard }
        }
    ]
}